module.exports = __webpack_public_path__ + "static/media/avatar_mouse.e0b5b08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_mouse.png
// module id = 390
// module chunks = 0